import classNames from 'classnames';
import { ReactNode } from 'react';
import {
    ModalOverlay,
    ModalOverlayProps,
    Modal as ReactAriaModal,
} from 'react-aria-components';

import StyleReset from '../StyleReset/StyleReset';

import styles from './Modal.module.css';

export type ModalProps = {
    children: ReactNode;
    width?: 'small' | 'regular' | 'large' | 'full';
    position?: 'middleCenter' | 'bottomCenter';
    backdrop?: 'none' | 'default';
} & Omit<
    ModalOverlayProps,
    'children' | 'className' | 'isEntering' | 'isExiting'
>;

/**
 * Modal is a component that displays content on top of the rest of the page.
 * It also captures focus within the modal.
 */
const Modal = ({
    children,
    backdrop,
    width = 'full',
    position = 'middleCenter',
    ...modalProps
}: ModalProps) => {
    const rootClasses = classNames(styles.Root, {
        [styles.hasBackdrop]: backdrop !== 'none',
        [styles.backdropDefault]: backdrop === 'default',
    });

    const modalClasses = classNames(styles.Modal, {
        [styles.Modal_middleCenter]: position === 'middleCenter',
        [styles.Modal_bottomCenter]: position === 'bottomCenter',
        [styles.Modal_sizeSmall]: width === 'small',
        [styles.Modal_sizeRegular]: width === 'regular',
        [styles.Modal_sizeLarge]: width === 'large',
    });

    return (
        <ModalOverlay className={rootClasses} {...modalProps}>
            <div className={styles.ContentWrapper}>
                <div className={styles.Grow} />

                <ReactAriaModal className={modalClasses}>
                    <StyleReset>{children}</StyleReset>
                </ReactAriaModal>
            </div>
        </ModalOverlay>
    );
};

export default Modal;
